import { render, staticRenderFns } from "./WelfareAttendanceImport.vue?vue&type=template&id=4d076ead"
import script from "./WelfareAttendanceImport.vue?vue&type=script&lang=js"
export * from "./WelfareAttendanceImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports